export default __webpack_public_path__ + "static/media/SupportImage.35bad97f.png";